@if (isDesktop()) {
<ion-split-pane when="lg" contentId="mainTabsContent" class="re-main-tabs-shell">
  <ion-menu contentId="mainTabsContent" class="re-main-sidebar">
    <ion-content class="re-main-sidebar__scroll">
      <div class="re-main-sidebar__inner">
        <a class="re-main-sidebar__brand" [routerLink]="brandLink" [replaceUrl]="true" [attr.aria-label]="'common.home' | translate">
          <re-app-brand-logo variant="full" size="compact" />
        </a>
        <nav class="re-main-sidebar__list" aria-label="Primary">
          @for (tab of tabs; track tab.id) {
            <a
              class="re-main-sidebar__item"
              [routerLink]="tabLink(tab.id)"
              [replaceUrl]="true"
              routerLinkActive="is-active"
              [routerLinkActiveOptions]="{ exact: tab.exact }"
            >
              <ion-icon [name]="tab.icon" aria-hidden="true"></ion-icon>
              {{ tab.labelKey | translate }}
            </a>
          }
        </nav>

        <footer class="re-main-sidebar__footer">
          <a class="re-main-sidebar__item" routerLink="/friends" routerLinkActive="is-active">
            <ion-icon name="people-circle-outline" aria-hidden="true"></ion-icon>
            {{ 'friends.title' | translate }}
          </a>
          <a class="re-main-sidebar__item" routerLink="/profile" routerLinkActive="is-active">
            <ion-icon name="person-circle-outline" aria-hidden="true"></ion-icon>
            {{ 'profile.title' | translate }}
          </a>
        </footer>
      </div>
    </ion-content>
  </ion-menu>

  <div id="mainTabsContent" class="ion-page re-main-tabs-content">
    <ion-tabs reSlidingTabs class="re-main-tabs re-main-tabs--desktop">
      <ion-tab-bar class="re-main-tab-bar" slot="bottom" [selectedTab]="selectedTab()" (ionTabButtonClick)="onMainTabClick($event)">
        @for (tab of tabs; track tab.id) {
          <ion-tab-button [tab]="tab.id">
            <ion-icon [name]="tab.icon"></ion-icon>
            {{ tab.labelKey | translate }}
          </ion-tab-button>
        }
      </ion-tab-bar>
    </ion-tabs>
  </div>
</ion-split-pane>
} @else {
<ion-tabs reSlidingTabs class="re-main-tabs">
  <ion-tab-bar class="re-main-tab-bar" slot="bottom" [selectedTab]="selectedTab()" (ionTabButtonClick)="onMainTabClick($event)">
    @for (tab of tabs; track tab.id) {
      <ion-tab-button [tab]="tab.id">
        <ion-icon [name]="tab.icon"></ion-icon>
        {{ tab.labelKey | translate }}
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
}
